import classNames from 'helpers/class-names'
import { FC, ReactElement } from 'react'
import { Switch } from '@headlessui/react'

type ToggleProps = {
  enabled: boolean
  setEnabled: (value: boolean) => void
  label?: string | ReactElement
  readonly?: boolean
  reverseOrder?: boolean
  labelClassName?: string
  className?: string
}

export const Toggle: FC<ToggleProps> = ({
  enabled,
  setEnabled,
  label,
  readonly = false,
  reverseOrder = false,
  labelClassName = '',
  className = '',
}) => {
  return (
    <Switch.Group>
      <div
        className={classNames(
          'flex flex-row items-center space-x-3',
          {
            'flex-row-reverse gap-2': reverseOrder,
          },
          className,
        )}>
        <Switch
          disabled={readonly}
          checked={enabled}
          onChange={setEnabled}
          className={classNames(
            {
              'bg-info': enabled,
              'bg-gray-200': !enabled,
              'cursor-not-allowed opacity-60': readonly,
            },
            'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-info/50 focus:ring-offset-1',
          )}>
          <span
            className={`${
              enabled ? 'translate-x-6' : 'translate-x-1'
            } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
          />
        </Switch>
        {Boolean(label) && typeof label === 'string' && (
          <Switch.Label className={classNames('text-gray-500', labelClassName)}>
            {label}
          </Switch.Label>
        )}
        {Boolean(label) && typeof label !== 'string' && label}
      </div>
    </Switch.Group>
  )
}
